import React from "react";

const Footer = () => {
  return (
    <footer className="flex bottom-0 sticky-bottom justify-between items-center p-4 bg-mv-darkblue shadow-md">
      <img
        src={`${process.env.PUBLIC_URL}/assets/header/mv-logo.svg`}
        alt="logo"
      />
    </footer>
  );
};

export default Footer;
